import { $axios, apiList } from '@/api'


export default {
    actions: {
        getEssayInfoById(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.essay.getEssayInfo.method,
                    params: {
                        wsfunction: apiList.essay.getEssayInfo.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getEssayAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.essay.getEssayAttempt.method,
                    params: {
                        wsfunction: apiList.essay.getEssayAttempt.moodle_method,
                        id: payload.id,
                        userid: payload.user
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        createEssayAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                const data = {
                    jobid: payload.id,
                    userid: payload.user,
                    blocks: [],
                    files: [],
                    link: payload.url
                }

                payload.content.forEach((blk, idx) => {
                    data.blocks.push({
                        id: blk.id,
                        content: blk.content
                    })
                })

                payload.files.forEach((file, idx) => {
                    data.files.push({
                        id: file.id,
                        draftid: file.draftid
                    })
                })

                $axios({
                    method: apiList.essay.createEssayAttempt.method,
                    params: {
                        wsfunction: apiList.essay.createEssayAttempt.moodle_method,
                    },
                    data
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err.originalMessage))
            })
        },
        checkEssayAcces(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.essay.checkEssayAccess.method,
                    params: {
                        wsfunction: apiList.essay.checkEssayAccess.moodle_method,
                        id: payload.id,
                        userid: payload.user
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getEssayAttempts(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.essay.getEssayAttempts.method,
                    params: {
                        wsfunction: apiList.essay.getEssayAttempts.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
